import { Rotas } from "./routes";

export default  function App () {
 return (
    <>
    <Rotas />
    </>
 );
};